import React, {useCallback, useEffect} from 'react';
import {observer} from 'mobx-react';
import {Loader} from '../../components';
import {startForm} from '../../../../_shared/GWTBridge/invoke/netForm';
import {ErrorScreen} from '../Error/ErrorScreens';
import {CompanyForm} from './CompanyForm';
import {formName} from './constants';
import {companyFormStore} from '../../store/OB_Company_Store';
import {onboardingMessageStore} from '../../store/OB_Message_Store';
import {priority} from '@priority-software/priority-proto-api/lib';
import {sendMonitor} from '../../../../utils/monitoring';

const ErrorType = priority.netitems.shared.Message.Type;

type Props = {
    onSubmit: (id: string) => void;
    id: string;
    isReadOnly?: boolean;
    onGoOutside?: (cbc?: () => void) => void;
};

export const CompanyDetails = observer(({onSubmit, id, onGoOutside, ...rest}: Props) => {
    const {isLoading, companyData, isSubmitting, isReadOnly} = companyFormStore;
    const {message, clearMessage} = onboardingMessageStore;

    useEffect(() => {
        (async () => await companyFormStore.getCompanyForm())();
    }, []);

    const goNext = useCallback(() => {
        onSubmit(id);
    }, [id, onSubmit]);

    const openCompanyScreen = useCallback(() => {
        sendMonitor('OnboardingTabsCompanyForm');
        const navigationCallback = () => startForm(formName);
        onGoOutside(navigationCallback);
    }, [onGoOutside]);

    const onHyperLinkClick = useCallback(
        async (linkData: {eName: string}) => {
            const navigationCallback = () => startForm(linkData.eName);
            onGoOutside(navigationCallback);
        },
        [onGoOutside]
    );

    if (isLoading) {
        return <Loader componentClasses="onboarding-loader" width={80} height={80} />;
    }

    if (message?.message?.MType === ErrorType.Fatal) {
        return (
            <ErrorScreen
                messageData={message}
                clearMessage={clearMessage}
                handler={companyFormStore.getCompanyForm}
            />
        );
    }

    return (
        <CompanyForm
            onHyperLinkClick={onHyperLinkClick}
            fieldUpdate={companyFormStore.fieldUpdate}
            isSubmitting={isSubmitting}
            goNext={goNext}
            isReadOnly={isReadOnly}
            companyData={companyData}
            saveCompanyData={companyFormStore.saveCompanyData}
            openCompanyScreen={openCompanyScreen}
        />
    );
});
